import { ConfirmTransferState } from './confirmTransfer.types'

export const confirmTransferInitialState: ConfirmTransferState = {
  loading: false,
  error: null,
  success: null
}

export default confirmTransferInitialState
